import React from 'react';
import logo from './logo.svg';
import './App.css';

import RootRouter from './router';

function App() {
  return (
    <RootRouter />
  );
}

export default App;
